import Nav from "./modules/nav.js";
import SectionObserver from "./modules/section-observer";
import Swiper, { Pagination, Autoplay } from "swiper/core";

// Main JS file

function init() {

  // Fixed header
  const header = document.querySelector('.header');
  if (header) {
    const fixedClass = 'header--fixed';
    const fixHeader = () => {
      header.classList.toggle(fixedClass, window.scrollY !== 0);
    };

    fixHeader();
    document.addEventListener('scroll', fixHeader);
  }

  // Nav
  Nav();
  SectionObserver();

  // Swiper
  const swiper = new Swiper('.swiper', {
    modules: [Pagination, Autoplay],
    loop: true,
    autoplay: {
      delay: 3000,
    },
    pagination: {
      el: '.swiper-pagination',
      type: 'bullets',
      clickable: true,
    },
  });

}

window.addEventListener('DOMContentLoaded', init);
